import React from "react";
import { Card, Col } from "react-bootstrap";
import ContentLoader from "react-content-loader";

type Props = {
  cardType: "list" | "details" | "checkout";
};

const CardLoader: React.FC<Props> = (props: Props) => {
  const { cardType } = props;

  return (
    <>
      {cardType === "list" && (
        <Card className="nothing-available-card">
          <Card.Body>
            <ContentLoader height="22" width="100%" viewBox="0 0 650 22">
              <rect x="0" y="0" rx="4" ry="4" width="650" height="22" />
            </ContentLoader>
            <ContentLoader height="80" width="100%" viewBox="0 0 280 80">
              <rect x="0" y="15" rx="4" ry="4" width="280" height="50" />
            </ContentLoader>
          </Card.Body>
        </Card>
      )}

      {cardType === "details" && (
        <Card className="details-card">
          <Card.Body>
            <dl className="eds-list eds-dl row gx-4">
              {Array(7)
                .fill("_", 0)
                .map((item, index) => (
                  <Col key={`details-${index}`} sm="6" lg="4" className="eds-list--item">
                    <ContentLoader viewBox="0 0 460 60">
                      <rect x="0" y="0" rx="0" ry="0" width="160" height="12" />
                      <rect x="0" y="20" rx="0" ry="0" width="200" height="20" />
                    </ContentLoader>
                  </Col>
                ))}
            </dl>
          </Card.Body>
        </Card>
      )}

      {cardType === "checkout" && (
        <Card className="checkout-card">
          <Card.Body>
            <Card.Title className="text-primary">Checkout</Card.Title>
            <div className="checkout-details flex-nowrap">
              <ContentLoader viewBox="0 0 240 40">
                <rect x="0" y="0" rx="0" ry="0" width="160" height="20" />
                <rect x="0" y="28" rx="0" ry="0" width="40" height="16" />
              </ContentLoader>
              <ContentLoader viewBox="0 0 240 22">
                <rect x="140" y="0" rx="0" ry="0" width="100" height="20" />
              </ContentLoader>
            </div>
            <ContentLoader viewBox="0 0 300 22">
              <rect x="0" y="0" rx="0" ry="0" width="300" height="20" />
            </ContentLoader>
            <br />
            <br />
            {Array(3)
              .fill("_", 0)
              .map((item, index) => (
                <div className="checkout-details flex-nowrap" key={`details-${index}`}>
                  <ContentLoader viewBox="0 0 240 18">
                    <rect x="0" y="0" rx="0" ry="0" width="100" height="16" />
                  </ContentLoader>
                  <ContentLoader viewBox="0 0 240 18">
                    <rect x="160" y="0" rx="0" ry="0" width="80" height="16" />
                  </ContentLoader>
                </div>
              ))}
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default CardLoader;
